// store/index.ts
import { configureStore, combineReducers, Reducer, Action } from '@reduxjs/toolkit'
import { staticReducers } from '../reducers' // Import adjusted staticReducers
import actionFormatCheckerMiddleware from '../middleware/action_format_checker_middleware'
import { viewsApi } from '@api/rtk/viewsApi'
import { fieldsApi } from '@api/rtk/fieldsApi'
import { fieldSelectOptionsApi } from '@api/rtk/fieldSelectOptionsApi'

// Middleware
const apisMiddleWare = [viewsApi.middleware, fieldsApi.middleware, fieldSelectOptionsApi.middleware]

// Define Async Reducers Type
type AsyncReducers = {
  [key: string]: Reducer<any, Action>
}

// Create Root Reducer with Dynamic Async Reducers
function createReducer(asyncReducers: AsyncReducers = {}) {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  })
}

// Configure Store with Injectable Reducers
const configureStoreWithInjectableReducers = (initialState = {}) => {
  const store = configureStore({
    reducer: createReducer(),
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().prepend(actionFormatCheckerMiddleware).concat(apisMiddleWare),
    preloadedState: initialState,
  })

  // Async Reducers Management
  const asyncReducers: AsyncReducers = {}

  // Inject Reducer Function
  const injectReducer = (key: string, asyncReducer: Reducer) => {
    if (!asyncReducers[key]) {
      asyncReducers[key] = asyncReducer
      store.replaceReducer(createReducer(asyncReducers))
    }
  }

  // Return store with injectReducer method
  return { ...store, injectReducer }
}

const store = configureStoreWithInjectableReducers()

export type RootState = ReturnType<ReturnType<typeof createReducer>>

/*
// Note: Old Webpack Hot module replacement for dynamic injectable reducers (optional)
if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('../reducers', () => {
    store.replaceReducer(createReducer())
  })
}
*/
export default store
